// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCl4Vzci4Hj9csFECXp1qG0LJGXZuMiTgQ",
  authDomain: "buttered-order-system.firebaseapp.com",
  projectId: "buttered-order-system",
  storageBucket: "buttered-order-system.firebasestorage.app",
  messagingSenderId: "855575418871",
  appId: "1:855575418871:web:783a95d98ebbcde18c40f2",
  measurementId: "G-9SXWRD3Y6G"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;